
(function(){
  /* When the popup opens by itself (20 Oct 2026)
     - "Open delay" now counts the visitor's time on the site in this visit, not the time on the current page:
       every page counts, but only while it is in front (sessionStorage "mialica_time_on_site", in milliseconds).
     - It opens once per visit at most, and it waits while the cookie banner, a drawer, the menu, another window
       (for example the 10% tab window) is open, or while the visitor is typing in a field.
     - It stays closed in a browser that has signed up through any Mialica newsletter form
       ("mialica_newsletter_subscribed"), and for the "Hide after dismissal" days after the 10% tab window
       was closed without signing up ("mialica_offer_dismissed").
     - Shopify marks every newsletter form on the page as sent, so the popup shows its thank-you or error message
       only when the address ends with this popup's own form mark (#MialicaPopupForm-...). */
  const TIME_KEY='mialica_time_on_site';
  const SHOWN_KEY='mialica_popup_auto_shown';
  const SUBSCRIBED_KEY='mialica_newsletter_subscribed';
  const OFFER_DISMISSED_KEY='mialica_offer_dismissed';
  const BUSY_SELECTOR='dialog[open], .mcd-drawer[aria-hidden="false"], .msd-drawer[aria-hidden="false"], .mh-mobile-panel[aria-hidden="false"], #iubenda-cs-banner.iubenda-cs-visible, #iubenda-iframe.iubenda-iframe-visible';

  function readNumber(store,key){
    try{ return Number(store.getItem(key)) || 0; }catch(e){ return 0; }
  }
  function writeValue(store,key,value){
    try{ store.setItem(key,String(value)); }catch(e){}
  }

  function init(root){
    if(!root || root.dataset.mbpReady === 'true') return;
    root.dataset.mbpReady='true';

    const overlay=root.querySelector('[data-mbp-overlay]');
    const dialog=root.querySelector('[data-mbp-dialog]');
    const closeBtn=root.querySelector('[data-mbp-close]');
    const skipBtn=root.querySelector('[data-mbp-skip]');
    const email=root.querySelector('[data-mbp-email]');
    const photo=root.querySelector('img[data-mbp-src]');
    const form=root.querySelector('form');
    const ownForm=!!(form && form.id) && window.location.hash === '#'+form.id;
    const anySent=root.dataset.success === 'true';
    const isSuccess=anySent && ownForm;
    const hasErrors=root.dataset.errors === 'true' && ownForm;
    const autoOpen=root.dataset.autoOpen === 'true';
    const delay=Math.max(0,Number(root.dataset.delay || 0))*1000;
    const rememberDays=Math.max(0,Number(root.dataset.rememberDays || 0));
    const storageKey='mialica_popup_dismissed_'+(root.dataset.popupKey || 'default');
    let lastFocused=null;
    let ticker=null;

    // A sign-up through any Mialica newsletter form on this page load.
    if(anySent && /[?&]customer_posted=true/.test(window.location.search)) writeValue(localStorage,SUBSCRIBED_KEY,Date.now());

    // The photo is not loaded with the page: its address waits in data attributes until the popup is about to open.
    function loadPhoto(){
      if(!photo || photo.dataset.mbpLoaded === 'true') return;
      photo.dataset.mbpLoaded='true';
      if(photo.dataset.mbpSrcset) photo.srcset=photo.dataset.mbpSrcset;
      photo.src=photo.dataset.mbpSrc;
    }

    function getStored(){
      try{
        const value=localStorage.getItem(storageKey);
        return value ? Number(value) : 0;
      }catch(e){ return 0; }
    }

    function shouldSuppress(){
      if(rememberDays <= 0) return false;
      const timestamp=getStored();
      if(!timestamp) return false;
      const maxAge=rememberDays*24*60*60*1000;
      return (Date.now()-timestamp) < maxAge;
    }

    function staysClosed(){
      if(shouldSuppress()) return true;
      if(readNumber(localStorage,SUBSCRIBED_KEY)) return true;
      if(readNumber(sessionStorage,SHOWN_KEY)) return true;
      const offerClosed=readNumber(localStorage,OFFER_DISMISSED_KEY);
      return !!offerClosed && rememberDays > 0 && (Date.now()-offerClosed) < rememberDays*24*60*60*1000;
    }

    function busy(){
      if(document.visibilityState === 'hidden') return true;
      if(overlay && overlay.classList.contains('is-open')) return true;
      if(document.querySelector(BUSY_SELECTOR)) return true;
      const active=document.activeElement;
      return !!(active && (active.isContentEditable || /^(INPUT|TEXTAREA|SELECT)$/.test(active.tagName)));
    }

    function rememberDismissal(){
      if(rememberDays <= 0) return;
      try{ localStorage.setItem(storageKey,String(Date.now())); }catch(e){}
    }

    function stopTimer(){
      if(ticker){ clearInterval(ticker); ticker=null; }
    }

    function openPopup(){
      if(!overlay || !dialog) return;
      stopTimer();
      loadPhoto();
      lastFocused=document.activeElement;
      overlay.classList.add('is-open');
      overlay.setAttribute('aria-hidden','false');
      // Marks the page while the popup is open: the stylesheet uses it to keep the floating chat and
      // cookie-preferences buttons from sitting on top of the popup (5 Oct 2026).
      document.documentElement.classList.add('mialica-popup-open');
      document.documentElement.style.overflow='hidden';
      document.body.style.overflow='hidden';
      // Focus without scrolling (5 Oct 2026). On phones the email field sits further down, and the browser used to
      // scroll the popup to it as soon as it opened, cutting off the photo, the words over it and the heading.
      // After a failed sign-up the field is still brought into view, so the message next to it is seen.
      const quiet=hasErrors ? undefined : {preventScroll:true};
      setTimeout(()=>{
        if(email && !isSuccess) email.focus(quiet);
        else dialog.focus(quiet);
      },120);
    }

    function closePopup(remember=true){
      if(!overlay) return;
      overlay.classList.remove('is-open');
      overlay.setAttribute('aria-hidden','true');
      document.documentElement.classList.remove('mialica-popup-open');
      document.documentElement.style.overflow='';
      document.body.style.overflow='';
      if(remember) rememberDismissal();
      if(lastFocused && typeof lastFocused.focus==='function') lastFocused.focus();
    }

    // Time on the site in this visit: only while the page is in front, a second at a time.
    // The popup also gives every page a few seconds of its own before it covers it.
    function startTimer(){
      let spent=readNumber(sessionStorage,TIME_KEY);
      let onPage=0;
      let last=Date.now();
      function tick(){
        const now=Date.now();
        if(document.visibilityState !== 'hidden'){
          const step=Math.min(Math.max(now-last,0),2000);
          spent+=step;
          onPage+=step;
        }
        last=now;
        writeValue(sessionStorage,TIME_KEY,Math.round(spent));
        // Fetch the photo a moment before the popup shows, so it is ready when it opens.
        if(spent >= delay-3000) loadPhoto();
        if(spent < delay || onPage < Math.min(delay,3000) || busy()) return;
        stopTimer();
        if(staysClosed()) return;
        writeValue(sessionStorage,SHOWN_KEY,Date.now());
        openPopup();
      }
      document.addEventListener('visibilitychange',()=>{ last=Date.now(); });
      ticker=setInterval(tick,1000);
      tick();
    }

    document.addEventListener('mialica:popup:open',openPopup);

    document.addEventListener('click',function(e){
      const trigger=e.target.closest('[data-mialica-popup-open]');
      if(trigger){
        e.preventDefault();
        openPopup();
      }
    });

    if(closeBtn) closeBtn.addEventListener('click',()=>closePopup(true));
    if(skipBtn) skipBtn.addEventListener('click',()=>closePopup(true));

    if(overlay){
      overlay.addEventListener('click',e=>{
        if(e.target===overlay && root.dataset.overlayClose==='true') closePopup(true);
      });
    }

    root.addEventListener('keydown',e=>{
      if(e.key==='Escape' && overlay.classList.contains('is-open')){
        e.preventDefault();
        closePopup(true);
        return;
      }

      if(e.key==='Tab' && overlay.classList.contains('is-open')){
        const focusables=[...dialog.querySelectorAll('a[href],button:not([disabled]),input:not([disabled]),[tabindex]:not([tabindex="-1"])')]
          .filter(el=>el.offsetParent!==null);
        if(!focusables.length) return;
        const first=focusables[0],last=focusables[focusables.length-1];
        if(e.shiftKey && document.activeElement===first){e.preventDefault();last.focus();}
        else if(!e.shiftKey && document.activeElement===last){e.preventDefault();first.focus();}
      }
    });

    if(isSuccess || hasErrors){
      openPopup();
      if(isSuccess) rememberDismissal();
    }else if(autoOpen && !Shopify.designMode && !staysClosed()){
      startTimer();
    }

    document.addEventListener('shopify:section:unload',function(e){
      if(e.target && e.target.contains(root)){
        stopTimer();
        document.documentElement.classList.remove('mialica-popup-open');
      }
    });
  }

  document.addEventListener('DOMContentLoaded',()=>{
    document.querySelectorAll('.mialica-branded-popup').forEach(init);
  });

  document.addEventListener('shopify:section:load',e=>{
    const root=e.target.querySelector('.mialica-branded-popup') ||
      (e.target.matches && e.target.matches('.mialica-branded-popup') ? e.target:null);
    if(root){
      init(root);
      if(window.Shopify && Shopify.designMode){
        document.dispatchEvent(new CustomEvent('mialica:popup:open'));
      }
    }
  });

  document.addEventListener('shopify:section:select',e=>{
    const root=e.target.querySelector('.mialica-branded-popup') ||
      (e.target.matches && e.target.matches('.mialica-branded-popup') ? e.target:null);
    if(root) document.dispatchEvent(new CustomEvent('mialica:popup:open'));
  });
})();
